import script from "./banner.vue?vue&type=script&setup=true&lang=js"
export * from "./banner.vue?vue&type=script&setup=true&lang=js"

import "./banner.vue?vue&type=style&index=0&id=6130256c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6130256c"]])

export default __exports__